module.exports = __webpack_public_path__ + "media/images/pic/brodno_building-cb4bdca35173940a550ed10ee06c5dbf.svg";